import script from "./OpenSourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenSourceView.vue?vue&type=script&setup=true&lang=js"

import "./OpenSourceView.vue?vue&type=style&index=0&id=22fe2026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fe2026"]])

export default __exports__